// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// Recompute the org-shared subset to persist AFTER removing one pinned chart / widget / layer:
// everything still tagged for THIS gdb, minus the removed id. Pure (no Esri/store imports) so the
// removal logic is unit-testable. Used by the dashboard's unpin wrappers, which then saveSharedPins
// this set — so a removed shared item is dropped from the org set instead of re-appearing on reload.
const sharedSetAfterRemoval = <T extends { id: string; sharedGdbId?: string }>(
  items: T[],
  gdbId: string,
  removedId?: string,
): T[] => items.filter((item) => item.sharedGdbId === gdbId && item.id !== removedId);

export default sharedSetAfterRemoval;
